import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { FormGroup } from "reactstrap";

import { isOptionAllowed } from "../../../shared/utils";
import { FIRST_SECOND_CONTACT, SECOND_EXECUTIVE } from "../../../helper/constants";
import { getOffertByQuotation } from "../../../redux/actions/offeringActions";

import mdiFileDocumentPlusOutline from '../../../shared/img/document-plus.svg';
import mdiFileArrowUpDownOutline from '../../../shared/img/document-arrow-up-down.svg';

import NewActivityModal from "../modals/NewActivityModal";
import NewGestionModal from "../modals/NewGestionModal";
import ReasignModal from "../modals/ReasignModal";

const initialExecutive = { label: '', value: '', sharpExist: false };

const GestionComponent = ({
  onClickModalNewActivity,
  handleActivityModalOpen,
  setActivityDescription,
  handleGetComponentData,
  getEvaluationStatus,
  getAllManagements,
  updateQuotation,
  setStateValue,
  handleNewActivity,
  updateQuotations,
  getStatusForm,
  getOffertByQuotation,
  loadingActivity,
  loadingReasing,
  quotationId,
  contact,
  values
}) => {

  const [gestionModal, setGestionModalOpen] = useState(false);
  const [reasingModal, setReasignModalOpen] = useState(false);
  const [executiveSelected, setExecutive] = useState(initialExecutive);

  useEffect(() => { isOptionAllowed(SECOND_EXECUTIVE) && getOffertByQuotation(quotationId) }, [getOffertByQuotation, quotationId]);

  const handleGestionModalOpen = () => {
    setGestionModalOpen(!gestionModal);
  }

  const handleReasignModalOpen = () => {
    setExecutive(initialExecutive);
    setReasignModalOpen(!reasingModal);
  }

  const handleReasignSubmit = (e) => {
    e.preventDefault();
    updateQuotations({
      action: 'assignExcecutive',
      executive: executiveSelected.value,
      quotations: [{ id: quotationId, isSharpspringInformed: false }]
    }, (status) => {
      if (status === 204) {
        handleReasignModalOpen();
        handleGetComponentData();
        getAllManagements(quotationId);
      }
    });
  }

  return (
    <div className="border_top_detail col-md-12">
      <NewGestionModal
        isOpen={gestionModal}
        toggle={handleGestionModalOpen}
        updateQuotation={updateQuotation}
        quotationId={quotationId}
        phones={contact ? contact.phones : []}
        emails={contact ? contact.emails : []}
        valuesHandler={{ values, setStateValue }}
      />
      <NewActivityModal
        isOpen={values.isOpenModalAssignActivity}
        toggle={handleActivityModalOpen}
        submit={handleNewActivity}
        setActivityDescription={setActivityDescription}
        activityDescription={values.activity.description}
        loading={loadingActivity}
      />
      <ReasignModal
        isOpen={reasingModal}
        toggle={handleReasignModalOpen}
        submit={handleReasignSubmit}
        setExecutive={setExecutive}
        loading={loadingReasing}
        values={values}
      />
      <div className="profile_info col-md-12">
        <FormGroup className="crm-gestion-container">
          <span className="datos-personales">Gestión de Cotización</span>
          <div className="crm-gestion-actions-btn">
            {isOptionAllowed(['first-contact-executive', 'admin', ...FIRST_SECOND_CONTACT]) &&
              <button type="button" onClick={handleGestionModalOpen}>
                <img src={mdiFileDocumentPlusOutline} alt="Nueva Gestión" />
                Nueva Gestión
              </button>
            }
            {isOptionAllowed(['first-contact-executive', 'admin']) &&
              <button type="button" onClick={handleReasignModalOpen}>
                <img src={mdiFileArrowUpDownOutline} alt="Reasignar" />
                Reasignar
              </button>
            }
            <button type="button" onClick={onClickModalNewActivity}>
              <img src={mdiFileArrowUpDownOutline} alt="Nueva Actividad" />
              Nueva Actividad
            </button>
          </div>
        </FormGroup>
      </div>
      <div className="profile_info col-md-12">
        <FormGroup className="details_profile_columned">
          <span className="datos-personales">Evaluación Cliente</span>
        </FormGroup>
      </div>
      {getEvaluationStatus()}
      {values.sentInformationRequest &&
        <Fragment>
          <div className="profile_info col-md-12">
            <FormGroup className="details_profile_columned">
              <span className="datos-personales">Estado Formulario</span>
            </FormGroup>
          </div>
          {getStatusForm()}
        </Fragment>
      }
    </div>
  );
}

const mapDispatchToProps = {
  getOffertByQuotation,
};

export default connect(null, mapDispatchToProps)(GestionComponent);